// About page — core values.

export const VALUES = [
  { t: "Reliability", d: "A delivery slot is a commitment. We plan capacity honestly and tell you early if anything changes." },
  { t: "Professionalism", d: "Our drivers are the face of your business at the delivery point, and they are briefed to behave that way." },
  { t: "Customer service", d: "One point of contact who knows your account, answers the phone and follows a job through to completion." },
  { t: "Safety", d: "Compliance is not a box to tick. Vehicles, hours and loads are checked to standards above the legal minimum." },
  { t: "Efficiency", d: "Well-planned routes mean fewer empty miles, lower cost per drop and a smaller footprint per consignment." },
  { t: "Innovation", d: "Live tracking, digital proof of delivery and route planning built around how your business actually works." },
];

export default VALUES;
